import PlaylistData from "../data/PlaylistData";
import { PlaylistItemData } from "../data/PlaylistItemData";
import {
  PlaylistDTO,
  PlaylistDTOCompanion,
} from "../../dto/v4/playlist/PlaylistDTO";
import { PlaylistItemDTO } from "../../dto/v4/playlist/PlaylistItemDTO";

class PlaylistMapper {
  public dataToPersistedMapper(): (d: PlaylistData) => PlaylistDTO {
    return this.mapDataToPersisted;
  }

  public persistedToDataMapper(): (p: PlaylistDTO) => PlaylistData {
    return (p: PlaylistDTO) => {
      const items: PlaylistItemData[] = p.items.flatMap(
        (i: PlaylistItemDTO, itemInMemoryId: number) => {
          if (i.songId) {
            return [{ id: itemInMemoryId, songEntryId: i.songId }];
          } else {
            return [];
          }
        },
      );
      return new PlaylistData(
        p.id,
        p.title,
        p.belongsToCrew,
        p.tags,
        items,
        p.createdAt,
        p.updatedAt,
        p.lastServerVersion,
        p.needsPush,
        p.isQrScannedPlaylist,
        p.isRemoved,
      );
    };
  }

  public mapDataToPersisted(d: PlaylistData): PlaylistDTO {
    return PlaylistDTOCompanion.create(
      d.id,
      d.title,
      d.getTags(),
      d.belongsToCrew,
      d.getItems().map((i) => ({ songId: i.songEntryId })),
      d.createdAt,
      d.updatedAt,
      d.lastServerVersion,
      d.needsPush,
      d.isQrCodeScannedPlaylist,
      d.isRemoved,
    );
  }
}

export default PlaylistMapper;
